import { DeviceInfo } from '../DeviceInfo';

export class PrintStartedEventArgs {
    public deviceInfo: DeviceInfo;
    public handled: boolean = false;

    constructor(deviceInfo: DeviceInfo) {
        this.deviceInfo = deviceInfo;
    }
}
